var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7321 10.5702H10.9907L10.7279 10.317C11.8541 9.00379 12.436 7.21227 12.1169 5.3082C11.6758 2.70064 9.4984 0.618348 6.87055 0.299438C2.90061 -0.188306 -0.440517 3.15087 0.0475131 7.11848C0.36661 9.74479 2.45012 11.9209 5.05921 12.3617C6.9644 12.6806 8.75697 12.0991 10.0709 10.9735L10.3243 11.2362V11.9772L14.313 15.9635C14.6978 16.3481 15.3266 16.3481 15.7114 15.9635C16.0962 15.579 16.0962 14.9505 15.7114 14.566L11.7321 10.5702ZM6.10096 10.5702C3.76405 10.5702 1.87763 8.68489 1.87763 6.34934C1.87763 4.0138 3.76405 2.12848 6.10096 2.12848C8.43788 2.12848 10.3243 4.0138 10.3243 6.34934C10.3243 8.68489 8.43788 10.5702 6.10096 10.5702Z",
    fill: "#231F20",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e94df388edeca1aab903ccc5b1df43a6.svg";
export { ForwardRef as ReactComponent };